import { sendTracking } from '../../utilities/js/tracking';
import './contact-salesforce.scss';

/**
 * Handles Salesforce contact form tracking behavior.
 *
 * The component listens for the first meaningful interaction with the form
 * and sends a single form-start tracking event.
 */
class ContactSalesforce {
    constructor(element) {
        // Defaults
        this.defaults = {
            initAttr: 'data-contactsalesforce'
        };

        // Elements
        this.$root = element;
        this.$form = this.$root.querySelector('form');

        // Properties
        this.trackingData = {
            event: 'form_start',
            elementCategory: 'form',
            elementText: window.location.href
        };
    }

    /**
     * Initializes the component when a form is available inside the root element.
     *
     * @returns {void} Does not return a value.
     */
    initialize() {
        if (this.$form) {
            this.trackFirstInteraction();
        }
    }
    /**
     * Registers listeners that track the first user interaction with the form.
     *
     * The tracking event is sent once, after which all temporary interaction
     * listeners are removed to avoid duplicate tracking calls.
     *
     * @returns {void} Does not return a value.
     */
    trackFirstInteraction() {
        const interactionEvents = ['input', 'change', 'focus'];

        const handleFirstInteraction = () => {
            if (this.formStart) return;

            interactionEvents.forEach(eventType => {
                this.$form.removeEventListener(eventType, handleFirstInteraction, true);
            });

            sendTracking(this.trackingData);
        };

        interactionEvents.forEach(eventType => {
            this.$form.addEventListener(eventType, handleFirstInteraction, true);
        });
    }
}

export { ContactSalesforce };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-contactsalesforce="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ContactSalesforce($root);
            $rootAPI.initialize();
        });
    }
});
